module.exports = __webpack_public_path__ + "img/400-e3d927.png";